import { Globe } from 'lucide-react';
import { useI18n } from '../../i18n/I18nProvider';
import type { CustomerOrder } from '../../types';

// Supporting context for the ordinary Current Sale. No cart or payment state.
export function ConfirmedMenuOrder({ order }: { order: CustomerOrder }) {
  const { t } = useI18n();
  const online = order.onlineOrder;
  if (!online) return null;
  const address = [online.area, online.street, online.building, online.floor, online.landmark].filter(Boolean).join(' · ');
  return <section data-testid="confirmed-current-sale" className="min-w-0 space-y-1 border-t border-line px-4 py-2 text-xs" aria-label={t.menu.orders.currentSaleOrigin}>
    <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-ink-muted">
      <span className="inline-flex items-center gap-1 font-semibold text-butcher-green"><Globe className="h-3 w-3" aria-hidden="true" />{t.menu.orders.currentSaleOrigin}</span>
      <bdi>{online.orderNumber}</bdi>
      <span className="rounded bg-surface-sunken px-1.5 py-0.5">{order.fulfilment === 'DELIVERY' ? t.menu.orders.delivery : t.menu.orders.pickup}</span>
      <bdi>{order.orderNumber}</bdi>
    </div>
    <p className="break-words"><span className="font-medium">{online.customerName}</span> · <bdi>{online.customerPhone}</bdi></p>
    {order.fulfilment === 'DELIVERY' && address ? <p className="break-words text-ink-muted">{address}</p> : null}
    {online.usdChangeFor ? <p className="text-xs">{t.menu.orders.usdChange.replace('{amount}', String(online.usdChangeFor))}</p> : null}
  </section>;
}
